var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedBullet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_1896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1672 21.7665L18.8801 29.4794C25.2681 27.776 30 21.9558 30 14.9999C30 14.858 30 14.716 30 14.5741L23.9432 8.99048L11.1672 21.7665Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3785 18.3595C16.041 19.022 16.041 20.1576 15.3785 20.8201L14.0063 22.1923C13.3438 22.8548 12.2082 22.8548 11.5457 22.1923L5.53627 16.1356C4.87381 15.4731 4.87381 14.3375 5.53627 13.675L6.90851 12.3028C7.57097 11.6403 8.70662 11.6403 9.36908 12.3028L15.3785 18.3595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6309 7.90212C21.2934 7.23966 22.429 7.23966 23.0915 7.90212L24.4637 9.27436C25.1262 9.93682 25.1262 11.0725 24.4637 11.7349L14.0536 22.0977C13.3912 22.7602 12.2555 22.7602 11.5931 22.0977L10.2208 20.7255C9.55835 20.063 9.55835 18.9274 10.2208 18.2649L20.6309 7.90212Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_1896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBullet);
export default __webpack_public_path__ + "static/media/checked-bullet.801465c70b5864d3ed504bcf113e260c.svg";
export { ForwardRef as ReactComponent };